import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

export default function Switch({ labels = ['خیر', 'بله'], value = false, values = [false, true], onChange , type='' }) {
    
    const [index, setIndex] = useState(0);
    const { t } = useTranslation();
    useEffect(() => {
        setIndex(values.indexOf(value));
    }, [value, values]);
    const {theme} = useSelector(store => store)

    return (
        <div className='mt10 text-center'>
            <label className={`${type !== 'userType' ? 'switch boolean' : 'switch'}`}>
                <input
                    type='checkbox'
                    checked={value === values[1]}
                    onChange={() => onChange(values[Math.abs(index - 1)])}
                />
                <span className={`${type !== 'userType' ? 'slider boolean' : 'slider'} ${theme}`} />
                {/* <div className={`${(value === true || value === false) ? 'text boolean' : 'text'} `}> */}
                {type === 'theme'? 
                 
                <div className={`images`}>
                    {labels.map((label)=>label)}
                </div>
                :
                <div className={`${type !== 'userType' ? 'text boolean' : 'text'} `}>
                    {
                        labels[index] === 'بله' ? t('Yes') : labels[index] === 'خیر' ? t('No') : labels[index]
                    }
                </div>
                }
            </label>
        </div>
    );
    
}